"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateProgramsIntoFlatSessionList = void 0;
/**
 * Översätter en lista med program till en lista med sessioner (med en nivå av program)
 */
const translateProgramsIntoFlatSessionList = (programs) => {
    const sessions = programs.map(program => {
        return program.sessions.map(session => {
            const programWithoutSessions = Object.assign(Object.assign({}, program), { sessions: [] });
            return Object.assign(Object.assign({}, session), { program: programWithoutSessions });
        });
    });
    const flattened = sessions.reduce((total, sess) => {
        return [...total, ...sess];
    }, []);
    return flattened;
};
exports.translateProgramsIntoFlatSessionList = translateProgramsIntoFlatSessionList;
//# sourceMappingURL=transform.js.map